import * as React from 'react';
import {
    activityFeedNoNotificationTitle,
    activityFeedNoNotificationSubTitle,
} from './ActivityFeedView.locstring.json';
import loc from 'owa-localize';
const EmptyStateIcon = require('../resources/EmptyIllustration.svg');
const styles = require('./ActivityFeed.scss');

export function EmptyStateView() {
    return (
        <div className={styles.emptyState}>
            <img className={styles.emptyIcon} src={EmptyStateIcon} role="presentation" />
            <div className={styles.emptyBoldText}>{loc(activityFeedNoNotificationTitle)}</div>
            <div className={styles.emptyText}>{loc(activityFeedNoNotificationSubTitle)}</div>
        </div>
    );
}
